import { useHistory } from "react-router-dom";

export function Semifinal() {
    let history = useHistory();
    window.open("https://semifinal.impactitb.com", "/");
    history.go(-1);
    return null;
  };